export default {"src":"/_next/static/media/content-hub-van.b60e44b2.svg","height":275,"width":1920,"blurWidth":0,"blurHeight":0};